import { NonogramCell } from "./NonogramCell";

export const NonogramRow = ({ cellStates, guaranteedCells, onCellClick, contradiction }) => (
    <div className="my-4">
        {contradiction && (
            <div className="mb-3 rounded-lg border border-red-300 bg-red-50 text-red-700 text-sm px-4 py-2 text-center">
                No valid arrangement satisfies these clues with the cells you've marked — try clearing a mark.
            </div>
        )}
        <div className={`overflow-x-auto -mx-4 px-4 sm:mx-0 sm:px-0 ${contradiction ? 'ring-2 ring-red-300 rounded-lg py-2' : ''}`}>
            <div className="flex gap-1 sm:gap-1.5 justify-start sm:justify-center min-w-max mx-auto">
                {cellStates.map((userState, index) => (
                    <NonogramCell
                        key={index}
                        index={index}
                        userState={userState}
                        deducedState={guaranteedCells ? guaranteedCells[index] : null}
                        interactive
                        onClick={onCellClick}
                        size="md"
                    />
                ))}
            </div>
        </div>
        <p className="text-xs text-gray-500 text-center mt-2">
            Click a cell to cycle: unknown → filled → crossed → unknown. Longer rows scroll horizontally on small screens.
        </p>
    </div>
);
